// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1rg0H","label":"CategoryService_label__3Rfxn","location":"CategoryService_location__2cqSv"};